import { customAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const googleChat = defineConnector({
  identifier: "googleChat",
  name: "Google Chat",
  tagLine: "Google Workspace messaging",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://chat\\.googleapis\\.com/.*",
  auth: customAuth("googleChat"),
  steps: [
    {
      title: "Create a service account",
      items: [
        {
          kind: "markdown",
          content:
            "In the [Google Cloud Console](https://console.cloud.google.com/), enable the **Google Chat API** for your project. Then go to **IAM & Admin → Service Accounts** and create a service account. Grant it the necessary Chat roles.",
        },
      ],
    },
    {
      title: "Generate a service account key",
      items: [
        {
          kind: "markdown",
          content:
            "In the service account details, go to the **Keys** tab and click **Add Key → Create new key**. Choose **JSON** format. Open the downloaded file and copy the entire JSON contents.",
        },
      ],
    },
    {
      title: "Enter your service account key",
      items: [
        {
          kind: "input",
          label: "Service account key (JSON)",
          placeholder: '{"type": "service_account", "project_id": "...", ...}',
          required: true,
          target: { kind: "secrets", field: "serviceAccountKey" },
          helperText: "Paste the entire JSON key file contents.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://chat.googleapis.com/v1/spaces",
      expectedStatus: [200, 403],
    }),
  },
});
